export default {
  name: "VarietyRow",
  props: {
    row: Array,
    colors: Array
  }
}
